var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SHIELD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m463 84.71a40 40 0 0 0 -20.87-18.82c-60-23.27-119-45.48-176.52-64.43a28.44 28.44 0 0 0 -18 0c-57.51 18.9-116.5 41.07-176.49 64.31a40 40 0 0 0 -19.12 15.94c.33.05-12.34 39.6-14.49 127-1.33 87.29 9.55 113.48 9.19 113.51 5.88 19.19 16.9 38.73 32.7 58.59 17.65 22.18 41.5 45.09 70.3 67.62 47.7 37.43 92.33 59.8 94.2 60.59a28.72 28.72 0 0 0 25.52 0c1.88-.79 46.56-23.23 94.23-60.65 28.81-22.54 52.67-45.45 70.33-67.62 16.92-21.27 28.36-42.14 33.89-62.64-.22 0 7.78-32.11 6.67-105.63-1.41-73.48-11.65-127.73-11.54-127.77z",
    fill: "#2ad352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.66 0a28.6 28.6 0 0 0 -9 1.45c-57.51 18.9-116.5 41.07-176.49 64.31a40 40 0 0 0 -19.17 15.95c.33.05-12.34 39.6-14.49 127-1.33 87.29 9.55 113.48 9.19 113.51 5.88 19.19 16.9 38.73 32.7 58.59q6.88 8.65 15 17.45 12.69 1.15 25.69 1.17c153.89 0 278.65-124.76 278.65-278.65a279 279 0 0 0 -10.35-75.5c-41.54-15.7-82.52-30.56-122.77-43.82a28.66 28.66 0 0 0 -8.96-1.46z",
    fill: "#74da7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382 206.31c-42.33 43.59-85.84 89.23-128.48 134.28a37 37 0 0 1 -26.95 11.63h-.17a38 38 0 0 1 -27-11.7c-22.83-23.63-45.82-47.21-68.66-70.34-14.61-14.76-14.16-38 .94-52.43s38.9-14.51 53.34.31q20.36 20.85 40.87 42c33.88-35.54 67.89-71.36 101-106.16 14.07-14.81 37.59-14.63 52.9 0s16.39 37.8 2.21 52.41z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.716776251fbc04d474c07c64a2d17a17.svg";
export { ForwardRef as ReactComponent };